// extracted by mini-css-extract-plugin
export var wrapper = "Item-module--wrapper--5ac6d";
export var description = "Item-module--description--738ce";
export var panel = "Item-module--panel--a22ae";
export var active = "Item-module--active--93e01";
export var arrowIcon = "Item-module--arrowIcon--72d6d";
export var title = "Item-module--title--2a4b6";
export var panelContentWrapper = "Item-module--panelContentWrapper--7dcb8";